export default defineAppConfig({
  ui: {
    colors: {
      primary: "byhours",
      secondary: "cyan",
      neutral: "slate",
      info: "teal",
      warning: "amber",
    },
    button: {
      slots: {
        base: "rounded-full backdrop-blur-sm cursor-pointer transition-opacity hover:opacity-95"
      },
      variants: {
        size: {
          xs: {
            base: "px-2.5 py-1.5"
          },
          sm: {
            base: "px-4 py-2.5"
          },
          lg: {
            base: "px-6 py-3"
          },
          xl: {
            base: "px-8 py-3.5"
          }
        }
      },
      compoundVariants: [
        {
          color: "neutral",
          variant: "link",
          class: "text-toned hover:text-default disabled:text-muted"
        }
      ]
    },
    fieldGroup: {
      variants: { 
        orientation: {
          horizontal: "inline"
        }
      }
    },
    tabs: {
      slots: {
        trigger: ["disabled:opacity-25"]
      },
      variants: {
        variant: {
          pill: {
            list: "rounded-full",
            indicator: "rounded-full",
          }
        }
      },
      compoundVariants: [{
        color: "primary",
        variant: "pill",
        class: {
          indicator: "bg-white",
          trigger: "data-[state=active]:text-highlighted data-[state=inactive]:text-toned"
        }
      }]
    },
    alert: {
      variants: {
        orientation: {
          vertical: {
            root: "items-center",
          }
        }
      }
    },
    select: {
      slots: {
        base: ["rounded-full"]
      }
    },
    selectMenu: {
      slots: {
        base: ["rounded-full w-full"],
        placeholder: "text-neutral-700",
      }
    },
    badge: {
      variants: {
        size: {
          xs: {
            base: "rounded-full"
          },
          sm: {
            base: "rounded-full"
          },
          md: {
            base: "rounded-full"
          },
          lg: {
            base: "rounded-full"
          },
          xl: {
            base: "rounded-full"
          }
        }
      }
    },
    breadcrumb: {
      defaultVariants: {
        color: "neutral"  
      },
      slots: {
        link: "text-xs"
      },
      variants: {
        active: {
          true: {
            link: "font-normal"
          }
        }
      }
    },
    input: {
      slots: {
        root: "w-full"
      }
    },
    inputNumber: {
      variants : {
        size: {
          xs: 'py-1.75'
        }
      }
    },
    checkbox: {
      slots: {
        base: "rounded-full"
      },
      variants: {
        indicator: {
          start: {
            wrapper: "ms-1"
          }
        }
      }
    },
    calendar: {
      slots: {
        cellTrigger: "m-0.5 sm:m-1"
      }
    },
    pageSection: {
      slots: {
        container: 'py-8 sm:py-16 lg:py-24'
      }
    },
    pageHero: {
      slots: {
        container: 'py-16',
      }
    }
  },
  channel_id: 1,
})